import { createContext, FC, PropsWithChildren, ReactElement, useContext } from 'react'

interface ScrollFollowContextValue {
    isScrolledAway: boolean
    scrollToBottom: () => void
}

const ScrollFollowContext = createContext<ScrollFollowContextValue | null>(null)

interface ScrollFollowProviderProps extends PropsWithChildren {
    value: ScrollFollowContextValue
}

/**
 * Unlike EditingMessageContext, this doesn't own its own state - the state lives in
 * useAutoScrollToBottom, called where its containerRef is (outside the <Channel> tree). This
 * just carries that hook's result down to whatever inside <Channel> needs to render off it (the
 * scroll-to-bottom notification), without threading it through props.
 */
export const ScrollFollowProvider: FC<ScrollFollowProviderProps> = ({ children, value }): ReactElement => (
    <ScrollFollowContext.Provider value={value}>
        {children}
    </ScrollFollowContext.Provider>
)

export const useScrollFollow = (): ScrollFollowContextValue => {
    const context = useContext(ScrollFollowContext)

    if (! context) {
        throw new Error('useScrollFollow must be used within a ScrollFollowProvider')
    }

    return context
}
